module.exports = __webpack_public_path__ + "static/media/completed-icon.ba5eebec.svg";